<template>
    <div id="service-contact-dashboard-view">
      <v-row>
        <v-col class="py-0">
          <v-breadcrumbs
            class="index-page-alignment"
            divider=">"
            :items="breadcrumbsList"
          >
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item
                :to="{ name: item.path }"
                :disabled="item.disabled"
                exact
              >
                {{ item.text }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col
          cols="12"
          md="12"
          lg="4"
        >
            <div class="px-0">
              <contact-info
                :loading="infoLoader"
                :contact-id="contactId"
                :contact-info="contactInfo"
              />
            </div>
            <div class="px-0" v-if="currentAccount.enable_marketing && userAccess.haveMarketingRole && checkContact">
              <contact-tags
                v-if="contactId"
                :contact-id="contactId"
                :contact="contactInfo.email"
                @notFound="notFound"
              />
              <contact-lists
                v-if="contactId"
                :contact-id="contactId"
                :contact="contactInfo.email"
              />
              <contact-brands
                v-if="contactId"
                :contact-id="contactId"
                :contact="contactInfo.email"
            />
            </div>
        </v-col>
        <v-col
          cols="12"
          md="12"
          lg="8"
          sm="12"
        >
          <v-tabs
            v-model="activeTab"
            height="48"
            color="#03b6fc"
            class="contact-dashboard-tabs"
            show-arrows
          >
            <v-tab
              v-for="tab in dashboardTabs"
              :id="tab.uniqueId"
              :key="tab.id"
              :href="tab.href"
              exact
              class="contact-dashboard-tab px-8"
              v-track="tab.uniqueId"
            >
              <span class="body-2 d-flex font-weight-regular tab-heading">
                {{ tab.name }}
                <div
                  v-if="tab.count > 0"
                  class=" d-flex align-center px-2"
                >
                  {{ `(${tab.count})` }}
                </div>  
              </span>
            </v-tab>
          </v-tabs>
          <v-divider />
          <v-tabs-items
            v-model="activeTab"
            style="background:#fafafa"
          >
            <v-tab-item
              v-for="tab in dashboardTabs"
              :key="tab.id"
              :value="tab.uniqueId"
              :transition="false"
              :reverse-transition="false"
            >
              <component
                :is="tab.component"
                :contact-info="contactInfo"
                :info-loader="infoLoader"
                :current-account="currentAccount"
                :roles="roles"
                @countEvent="handleCountData"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </div>
</template>
<script>
  import { $serviceContacts } from "@core/services"
  import ContactInfo from './ContactInfo.vue'
  import Overview from './Overview'
  import Campaigns from '../components/Campaigns'
  import Tickets from '../components/Tickets'
  import Orders from '../components/Orders'
  import AbandonedCarts from '../components/AbandonedCarts'
  import { mapGetters } from 'vuex'
  import ContactLists from '../marketing/ContactLists.vue'
  import ContactBrands from '../marketing/ContactBrands.vue'
  import ContactTags from '../marketing/ContactTags.vue'

  export default {
    name: "contact-dashboard",
    components: {
      ContactInfo,
      Overview,
      Campaigns,
      Tickets,
      Orders,
      AbandonedCarts,
      ContactLists,
      ContactTags,
      ContactBrands
    },
    data() {
      return {
        breadcrumbsList: [
          {
            text: "Contacts",
            disabled: false,
            path: "contact-list",
          },
          {
            text: "Dashboard",
            disabled: false,
            path: "",
          },
        ],
        contactId: null,
        activeTab: '',
        dashboardTabs: [],
        contactInfo: {},
        infoLoader: false,
        checkContact: true
      };
    },
    computed: {
      ...mapGetters({
        currentAccount: 'auth/account.current',
        roles: 'auth/roles',
        userAccess:'auth/userAccess'
      }),
    },
    mounted() {
      this.contactId = this.$route.params.contactId
      this.dashboardTabs = [
        {
          id: 1,
          uniqueId: 'overview',
          name: 'OVERVIEW',
          href: '#overview',
          component: 'Overview',
          count: 0,
          access: true
        },
        {
          id: 2,
          uniqueId: 'campaigns',
          name: 'CAMPAIGNS',
          href: '#campaigns',
          component: 'Campaigns',
          count: 0,
          access: this.currentAccount.enable_marketing && this.roles.includes('contacts')
        },
        {
          id: 3,
          uniqueId: 'tickets',
          name: 'TICKETS',
          href: '#tickets',
          component: 'Tickets',
          count: 0,
          access: this.currentAccount.enable_service && this.$can('read','contacts')
        },
        {
          id: 4,
          uniqueId: 'orders',
          name: 'ORDERS',
          href: '#orders',
          component: 'Orders',
          count: 0,
          access: true
        },
        {
          id: 5,
          uniqueId: 'abandoned-carts',
          name: 'Abandoned Cart List',
          href: '#abandoned-carts',
          component: 'AbandonedCarts',
          count: 0,
          access: this.currentAccount.enable_marketing && this.roles.includes('contacts')
        },
      ]
      this.dashboardTabs = this.dashboardTabs.filter((tab) => tab.access)
      this.getSingleContact(this.contactId)
    },
    methods: {
      notFound(error){
       this.checkContact = error
      },
      getSingleContact(contactId) {
        this.infoLoader = true;
        $serviceContacts.fetchSingle(contactId, {}).then(response => {
          if (response.data) {
            this.contactInfo = response.data
            this.breadcrumbsList[1].text = `${this.contactInfo.first_name} ${this.contactInfo.last_name}`
            this.infoLoader = false;
          }
        }).catch(error =>  {
          if(error.response.status === 404){
            this.$store.dispatch("ui/snackbar", [
              {
                title: "Invalid Contact",
                message: "Contact not found.",
                type: "error",
              },
            ]);
            this.$router.push({ name: 'contact-list' })
          }
        })
        .finally(() => {
          this.infoLoader = false;  
        })
      },
      /**
      * update the Tab badge data count
      */
      handleCountData (data) {
        if (this.currentAccount.enable_marketing
          && this.currentAccount.enable_service
          && this.$can('read','contacts')
          && this.roles.includes('contacts')
        ) {
          this.dashboardTabs[1].count = data.count.campaigns
          this.dashboardTabs[2].count = data.count.tickets
          this.dashboardTabs[3].count = data.count.orders
          this.dashboardTabs[4].count = data.count.abCarts
        } else if (
          this.currentAccount.enable_marketing
          && this.roles.includes('contacts')
        ) {
          this.dashboardTabs[1].count = data.count.campaigns
          this.dashboardTabs[2].count = data.count.orders
          this.dashboardTabs[3].count = data.count.abCarts
        } else {
          this.dashboardTabs[1].count = data.count.tickets
          this.dashboardTabs[2].count = data.count.orders
        }
      },
    },
  };
  </script>
  <style lang="scss">
  #service-contact-dashboard-view {
    h3{
      font-family: "Montserrat", sans-serif !important;
      font-weight: 600 !important;
    }
 
    .v-tab {
      padding: 0 28px;
      .tab-heading {
        color: #484848;
      }
    }
    .v-tab--active .tab-heading {
      color: #03b6f9;
    }
    .v-breadcrumbs__item--disabled {
      color: #000000;
    } 
    .data-count {
      background: #727272;
      border-radius: 11px;
      margin-left: 5px;
      font-family: "Montserrat", sans-serif !important;
      align-items: center;
      height: 20px;
      color: #FFFFFF;
    }
    .service-order-view {
      padding: 24px 12px 24px 12px !important;
      .order-line-item {
        padding: 10px;
      }
      .expanded-inner-header {
        margin-bottom: 8px;
      }
    }
    .service-ticket-view {
      padding: 24px 12px !important;
    }
    .service-campaign-view {
      padding: 24px 12px !important;
    }
    .service-abandoned-view {
      padding: 24px 12px 30px 12px !important;
      .order-line-item {
        padding: 10px;
      }
      .expanded-inner-header {
        margin-bottom: 8px;
      }
    }
    .customer-engagement-service {
      .service-ticket-view, .service-other-view, .service-order-view {
        padding: 12px 0px !important;
      }
      .v-navigation-drawer--temporary:not(.v-navigation-drawer--close){
        box-shadow: 0px 8px 10px 2px rgba(0, 0, 0, 0.2) !important;
      }
      .service-abandoned-view {
        padding: 12px 0px !important;
        .order-line-item {
          padding: 10px;
        }
        .expanded-inner-header {
          margin-bottom: 8px;
        }
      }
    }
    .service-ticket-view .ticket-section, .title-section {
      margin-bottom: 10px !important;
    }
    .mdi-chevron-left:hover{
      border-radius: 50%;
      background-color:#F0F0F0;
    }
    .mdi-chevron-right:hover{
      border-radius: 50%;
      background-color: #F0F0F0;
    }
  }
  </style>
  